var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 4.66699H16.3334C13.7561 4.66699 11.6667 6.75633 11.6667 9.33366V46.667C11.6667 49.2443 13.7561 51.3337 16.3334 51.3337H39.6667C42.2441 51.3337 44.3334 49.2443 44.3334 46.667V9.33366C44.3334 6.75633 42.2441 4.66699 39.6667 4.66699Z",
    stroke: "#853B00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 42H28.0225",
    stroke: "#853B00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 11,
    width: 22,
    height: 28,
    fill: "#F8EEE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmartphone);
export default __webpack_public_path__ + "static/media/icon-smartphone.f5ca42f1cf4dcb42223bb17ea2775168.svg";
export { ForwardRef as ReactComponent };